import React, {useMemo} from 'react';

import {useUnit} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {ROUTES} from '@/app/routing';
import {colors} from '@/app/styles/theme';
import {userModel} from '@/entities/user/model';
import {TAXPAYER_ROLES, useUserPermissions} from '@/entities/user/permissions';
import {PermissionAccess} from '@/features/PermissionAccess';
import {DropdownMenu} from '@/shared/ui/DropdownMenu';

import {Icon} from '@/shared/ui/Icon';
import {history} from '@shared/lib/history';

import {Avatar, UserMenuContainer, UserMenuLabel} from './styled';

const GEN_INFO = 'page_employers_control.user_menu';

export const UserMenu = () => {
    const {defaultPrivateRoute, profilePath} = useUserPermissions();
    const {t: translation} = useTranslation();
    const t = (key: string, vars?: Record<string, any>) =>
        translation(`${GEN_INFO}.${key}`, vars ?? {});
    const user = useUnit(userModel);
    const bullets = useMemo(() => {
        if (user.state.name) {
            const {firstName, lastName} = user.state.profile ?? {};
            return {
                label: `${firstName ?? ''} ${lastName ?? ''}`,
                avatar:
                    (firstName?.charAt(0).toUpperCase() ?? '') +
                    (lastName?.charAt(0).toUpperCase() ?? ''),
            };
        }
        return {};
    }, [user.state.name]);
    return (
        <div
            style={{
                width: 'fit-content',
                height: 'auto',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: colors.brandPrimary,
            }}
        >
            <UserMenuLabel>{bullets.label}</UserMenuLabel>
            <DropdownMenu
                noIcon={true}
                label={
                    <UserMenuContainer>
                        <Avatar>{bullets.avatar}</Avatar>
                        <Icon name="arrowBottom" size={10} color={colors.lightGrey} />
                    </UserMenuContainer>
                }
            >
                <DropdownMenu.List style={{zIndex: 1200, position: 'relative'}}>
                    {!user.isAdminDDA && (
                        <DropdownMenu.Item
                            style={{display: 'flex', alignItems: 'center', gap: 8}}
                            onSelect={() => {
                                history.push(profilePath ?? defaultPrivateRoute);
                            }}
                        >
                            <Icon name="profile" size={24} fill={colors.brandPrimary} />
                            {t('Profile')}
                        </DropdownMenu.Item>
                    )}
                    <PermissionAccess roles={TAXPAYER_ROLES}>
                        <DropdownMenu.Item
                            style={{display: 'flex', alignItems: 'center', gap: 8}}
                            onSelect={() => {
                                history.push(ROUTES.SUBSCRIPTIONS);
                            }}
                        >
                            <Icon name="subscription" size={24} fill={colors.brandPrimary} />
                            {t('Subscription')}
                        </DropdownMenu.Item>
                    </PermissionAccess>
                    <DropdownMenu.Item
                        style={{display: 'flex', alignItems: 'center', gap: 8}}
                        onSelect={() => {
                            user.logout(false);
                        }}
                    >
                        <Icon name="logout" size={24} color={colors.brandPrimary} />
                        {t('Logout')}
                    </DropdownMenu.Item>
                </DropdownMenu.List>
            </DropdownMenu>
        </div>
    );
};
